var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.emptyStatistics
    ? _c("div", [
        _c("h6", [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$tc("global.words.sent", 1)) + ": "),
          ]),
          _vm._v(
            "\n    " + _vm._s(_vm._f("setNAValue")(_vm.send.count)) + "\n  "
          ),
        ]),
        _vm._v(" "),
        _c("h6", [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$t("global.words.delivered")) + ": "),
          ]),
          _vm._v(
            "\n    " + _vm._s(_vm._f("setNAValue")(_vm.delivery.count)) + "\n  "
          ),
        ]),
        _vm._v(" "),
        _c("h6", [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$t("campaigns.statistics.uniqueOpens")) + ": "),
          ]),
          _vm._v(
            "\n    " + _vm._s(_vm._f("setNAValue")(_vm.open.unique)) + "\n    "
          ),
          _c("span", { staticClass: "tiny-f" }, [
            _vm._v(
              "(" +
                _vm._s(_vm.$t("campaigns.statistics.openRate")) +
                ":\n      " +
                _vm._s(_vm._f("parsePercentage")(_vm.open.rate)) +
                ".\n      " +
                _vm._s(_vm.$t("campaigns.statistics.totalOpens")) +
                ":\n      " +
                _vm._s(_vm._f("setNAValue")(_vm.open.count)) +
                ")"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("h6", [
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$tc("global.words.click", 2)) + ": "),
          ]),
          _vm._v(
            "\n    " + _vm._s(_vm._f("setNAValue")(_vm.clicks.count)) + "\n  "
          ),
        ]),
      ])
    : _c("div", [
        _vm.notSentYet
          ? _c("p", { staticClass: "grey-text" }, [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "automations.applicationLevel.thisAutomationHasNotBeenTriggered"
                    )
                  ) +
                  "\n  "
              ),
            ])
          : _c("p", { staticClass: "grey-text" }, [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "automations.applicationLevel.thereAreNoStatisticsForThisAutomation"
                    )
                  ) +
                  "\n  "
              ),
            ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }